<h2 class="heading-4">Check your details</h2>

<p class="body mb-12 mt-8">If anything looks wrong, you can update your contact info here.</p>

<section class="inputs flex-col gap-16 max-w-320">
  <section>
    <app-text-input name="email" label="Email" [ngModel]="vm.formValue?.['email']" [error]="vm.errors?.email">
      @if (vm.errors?.email) {
        <i icon-end class="fa-light fa-circle-exclamation error-icon"></i>
      }
    </app-text-input>
    @if (vm.errors?.email) {
      <section class="error mt-4 error-margin">
        <i class="fa-light fa-circle-exclamation hint-icon"></i>
        @if (vm.errors?.email?.['required']) {
          <p class="hint error-text" data-testid="email-required-error">Enter an email address.</p>
        } @else {
          <p class="hint error-text" data-testid="email-invalid-error">Enter a valid email address.</p>
        }
      </section>
    }
  </section>

  <section>
    <app-text-input name="mobile" label="Mobile" [ngModel]="vm.formValue?.['mobile']" [error]="vm.mobileError">
      @if (vm.mobileError) {
        <i icon-end class="fa-light fa-circle-exclamation error-icon"></i>
      }
    </app-text-input>
    @if (vm.showMobileSpecificErrors) {
      <section class="error mt-4 error-margin">
        <i class="fa-light fa-circle-exclamation hint-icon"></i>
        @if (vm.errors?.mobile?.['not_valid_mobile']) {
          <p class="hint error-text" data-testid="mobile-invalid-number-error">Please enter a valid phone number.</p>
        } @else {
          <p class="hint error-text" data-testid="mobile-invalid-text-error">Must be 11 numbers or fewer.</p>
        }
      </section>
    }
  </section>

  <section>
    <app-text-input name="landline" label="Landline" [ngModel]="vm.formValue?.['landline']" [error]="vm.landlineError">
      @if (vm.landlineError) {
        <i icon-end class="fa-light fa-circle-exclamation error-icon"></i>
      }
    </app-text-input>
    @if (vm.showLandlineSpecificErrors) {
      <section class="error error-margin mt-4">
        <i class="fa-light fa-circle-exclamation hint-icon"></i>
        @if (vm.errors?.landline?.['not_valid_landline']) {
          <p class="hint error-text" data-testid="landline-invalid-number-error">Please enter a valid phone number.</p>
        } @else {
          <p class="hint error-text" data-testid="landline-invalid-text-error">Must be 11 numbers or fewer.</p>
        }
      </section>
    }
  </section>

  @if (vm.errors?.section) {
    <section class="error">
      <i class="fa-light fa-circle-exclamation"></i>
      <p class="body" data-testid="phone-required-error">Enter at least one phone number</p>
    </section>
  }

  <section class="flex-col">
    <p class="label mb-8">Repair address</p>

    @for (line of vm.address; track line) {
      <p qmBlock class="body address-line">
        {{ line }}
      </p>
    }
  </section>
</section>
<div>
  <div class="divider"></div>
</div>
